import { css } from 'lit';
import { fsDesignToken } from '../../core/style-util.js';

export const style = css`
  .error-message-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .error-heading {
    font-size: ${fsDesignToken('fsFontHeadingLarge')};
    font-weight: ${fsDesignToken('fsFontWeightLight')};
    line-height: ${fsDesignToken('fsFontLineHeightSmall')};
    margin: 0 0 0 16px;
  }

  p {
    padding: 0 0.5em;
    text-align: center;
  }
`;
